import React from "react";
import { createEpiCharacterScene } from "./epiCharacterScene.js";

const ASSET_BASE = import.meta.env.BASE_URL || "/static/react/";
const assetSource = (file) => `${ASSET_BASE}epi/lumi-${file}`;
const SEARCHING = ["Je cherche dans le Guide…", "Je vérifie les sections utiles…", "Je prépare la réponse…"];

// La répartitrice accompagne la fenêtre de Lumi : le suivi de la recherche reste lisible dans la fenêtre.
export default function EpiCharacter({ phase }) {
  const rootRef = React.useRef(null);
  const stageRef = React.useRef(null);
  const sceneRef = React.useRef(null);
  const dragRef = React.useRef(null);
  const previousPhaseRef = React.useRef(phase);
  const [bubble, setBubble] = React.useState("");

  React.useEffect(() => {
    const scene = createEpiCharacterScene(stageRef.current, assetSource);
    sceneRef.current = scene;
    return () => scene?.destroy();
  }, []);

  React.useEffect(() => {
    const finished = previousPhaseRef.current === "thinking" && phase === "answered";
    previousPhaseRef.current = phase;
    // À la réponse, elle passe de la lecture au Gantt sans d'abord redescendre sa tablette.
    if (finished) sceneRef.current?.found();
    else sceneRef.current?.setThinking(phase === "thinking");
    if (phase === "thinking") {
      let step = 0;
      setBubble(SEARCHING[0]);
      const timer = window.setInterval(() => setBubble(SEARCHING[++step % SEARCHING.length]), 2800);
      return () => window.clearInterval(timer);
    }
    setBubble(finished ? "Réponse prête." : "");
    if (!finished) return undefined;
    const timer = window.setTimeout(() => setBubble(""), 2800);
    return () => window.clearTimeout(timer);
  }, [phase]);

  const startDrag = (event) => {
    event.currentTarget.setPointerCapture(event.pointerId);
    dragRef.current = { x: event.clientX - rootRef.current.offsetLeft, y: event.clientY - rootRef.current.offsetTop };
  };
  const moveDrag = (event) => {
    if (!dragRef.current) return;
    const root = rootRef.current;
    root.style.left = `${Math.min(window.innerWidth - root.offsetWidth / 2, Math.max(-root.offsetWidth / 2, event.clientX - dragRef.current.x))}px`;
    root.style.top = `${Math.min(window.innerHeight - root.offsetHeight / 2, Math.max(0, event.clientY - dragRef.current.y))}px`;
  };

  return (
    <div aria-hidden="true" className="epi-character" ref={rootRef}>
      <div className="epi-character__stage" ref={stageRef}>
        <img alt="" draggable={false} />
        <canvas height={900} width={720} />
      </div>
      <div
        className="epi-character__grip"
        onMouseDown={(event) => event.preventDefault()}
        onPointerCancel={() => { dragRef.current = null; }}
        onPointerDown={startDrag}
        onPointerMove={moveDrag}
        onPointerUp={() => { dragRef.current = null; }}
      />
      {bubble ? <div className="epi-character__bubble">{bubble}</div> : null}
    </div>
  );
}
